import axios from "axios";
import {config} from "../constants";
import authHeader from "./auth-header";
import CommonService from "./common.service";

class TransactionService {

    pushTest(customerNo) {
        return axios.post(
            config.API_URL + "transaction/push-test/" + customerNo,
            {
                lang: CommonService.getLang()
            },
            {headers: authHeader()}
        );
    }

    search(riskLevel, dateType, startDate, endDate, filterCriteria) {
        return axios.post(
            config.API_URL + "transaction/search",
            {
                riskLevel: riskLevel,
                dateType: dateType,
                startDate: startDate,
                endDate: endDate,
                filterCriteria: filterCriteria,
                lang: CommonService.getLang()
            },
            {headers: authHeader()}
        );
    }

    riskLevels() {
        return axios.get(config.API_URL + "transaction/risk-levels", {headers: authHeader()});
    }

    takeAction(txId, action) {
        return axios.post(
            config.API_URL + "transaction/take-action",
            {
                txId: txId,
                action: action,
                lang: CommonService.getLang()
            },
            {headers: authHeader()}
        );
    }

}

export default new TransactionService();
